import { StubHubRoutesEnum } from "models/enums/apiRoutes/stubHubApiRoutes";


import { IApiBaseResponse } from "models/interfaces/Iglobal";
import axiosClient from "sharedServices/api/axios.services";
export class BotPerformanceDashboardService {
    public getBotPerformanceData = async () => {
      return axiosClient.get<IApiBaseResponse<any>>(
        StubHubRoutesEnum.DASHBOARD_BOT_PERFORMANCE_DATA,
        {
          params: null,
        }
      );
    };
}